import { Controller } from "stimulus";
import csrfPrefilter from "../components/csrf_prefilter";
import $ from 'jquery';

export default class extends Controller {
  static targets = [ "step" ]

  initialize() {
    this.index = 0
  }

  next() {
    this.stepTargets[this.index].classList.add("hidden");
    this.index ++;
    this.stepTargets[this.index].classList.remove("hidden");
  }

  markRead() {
    csrfPrefilter();
    $.ajax({
      type: "patch",
      url: `/profiles/mark_read_offer_guide`,
      contentType: 'application/json'
    })
  }
}
